import introJs from "intro.js"
import { Log } from "src/util/classes/log"
import { showNotImplementedNotification } from "src/util/functions/notifications"

const prevLabel = "<i class='fa-regular text-primary fa-chevron-left'/>"
const nextLabel = "<i class='fa-regular text-white fa-chevron-right'/>"
const doneLabel = "<i class='fa-regular text-white fa-close'/>"

export function startHelpTour(steps: unknown[]) {
  introJs()
    .setOptions({
      showBullets: false,
      disableInteraction: true,
      hidePrev: true,
      prevLabel,
      nextLabel,
      doneLabel,
      // Because for some reason they removed the typings for this...
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      steps: steps,
    })
    .start()
}

export function helpTourNotImplemented(pageName: string) {
  showNotImplementedNotification()
  Log.info(`Help tour needs to be implemented for ${pageName}.`)
}
